import { PersonRounded } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import useResponsive from "../hooks/useResponsive";
import UserDropdown from "./UserDropdown";
import { COLORS } from "../../ui/Theme";
import { useMainLayoutContext } from "../../context/MainLayoutContext";

const UserAvatar = () => {
  const { fullname } = useMainLayoutContext();
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);
  const { isMd } = useResponsive();

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpenDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box ref={dropdownRef}>
      <Box
        onClick={() => setIsOpenDropdown(!isOpenDropdown)}
        sx={{
          bgcolor: isOpenDropdown && COLORS.SOFTGRAY,
          borderRadius: "12px",
          padding: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px",
          cursor: "pointer",
          ":hover": {
            bgcolor: COLORS.SOFTGRAY,
          },
        }}
      >
        {isMd && <Typography fontSize={"20px"}>{fullname}</Typography>}
        <PersonRounded sx={{ color: COLORS.DARKGRAY, width: "24px" }} />
      </Box>
      {isOpenDropdown && <UserDropdown setIsOpenDropdown={setIsOpenDropdown} />}
    </Box>
  );
};

export default UserAvatar;
